import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SubscriptionQueryType } from '../interface/SubscriptionUtilType';
import { makeApolloClientRequest } from '../apolloClientHelper';
import { GET_VBC_USER_SUBSCRIPTION, GET_VBC_USER_SUBSCRIPTION_STATUS, GET_VBC_USER_SUBSCRIPTION_WITH_MOP, GET_VBC_USER_SUBSCRIPTION_WITH_MOP_BYSUBSCRITPIONID } from '../../../gql/queries';
import { ApolloErrorPolicy, ApolloFetchPolicy } from '@chegg/utils';
import configureApolloForCommerce from '../../../gql/configureApolloForCommerce';
import { APOLLO_COMMERCE_CONTEXT } from '../../../gql/constants';
import { isProd } from '../../../common/helper';
/**
 * Get My Latest Subscription V1 response for client side requests
 * @param ClientSideRequestParams
 * @returns SubscriptionUtilResponseType<MyLatestSubscriptionsV1WithDates>
 */
export var getClientSideMyLatestSubscriptionWithDates = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
    var environment, queryType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          environment = request.environment;
          if (environment) {
            configureApolloForCommerce(isProd(environment.toString()), window.location.hostname);
          }
          queryType = SubscriptionQueryType.WITH_DATES;
          return _context.abrupt("return", makeRequest(request, GET_VBC_USER_SUBSCRIPTION, queryType));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getClientSideMyLatestSubscriptionWithDates(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Get My Latest Subscription V1 Status only response for client side requests
 * @param ClientSideRequestParams
 * @returns SubscriptionUtilResponseType<MyLatestSubscriptionsV1WithStatus>
 */
export var getClientSideMyLatestSubscriptionStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request) {
    var queryType;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          queryType = SubscriptionQueryType.WITH_STATUS;
          return _context2.abrupt("return", makeRequest(request, GET_VBC_USER_SUBSCRIPTION_STATUS, queryType));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getClientSideMyLatestSubscriptionStatus(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Get My Latest Subscription V1 response with MOP details for client side requests
 * @param ClientSideRequestParams
 * @returns SubscriptionUtilResponseType<MyLatestSubscriptionsV1WithMop>
 */
export var getClientSideMyLatestSubscriptionWithMop = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", makeRequest(request, GET_VBC_USER_SUBSCRIPTION_WITH_MOP, SubscriptionQueryType.WITH_MOP));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getClientSideMyLatestSubscriptionWithMop(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Get My Latest Subscription V1 response with MOP details for client side requests for logging
 * @param ClientSideRequestParams
 * @returns SubscriptionUtilResponseType<MySubscriptionV1WithMopForLogging>
 */
export var getClientSideSubscritionByIdWithMopForLogging = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(variables, _ref4) {
    var teamName, apolloClient, location;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          teamName = _ref4.teamName, apolloClient = _ref4.apolloClient;
          location = getWindowLocation() || "clientside request subscription by id";
          return _context4.abrupt("return", makeApolloClientRequest(apolloClient, {
            fetchPolicy: ApolloFetchPolicy.NO_CACHE,
            errorPolicy: ApolloErrorPolicy.ALL,
            query: GET_VBC_USER_SUBSCRIPTION_WITH_MOP_BYSUBSCRITPIONID,
            variables: variables
          }, {
            teamName: teamName,
            location: location
          }));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getClientSideSubscritionByIdWithMopForLogging(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();
var getWindowLocation = function getWindowLocation() {
  return typeof window !== 'undefined' ? window.location.href : '';
};
var makeRequest = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6, query, queryType) {
    var teamName, apolloClient, environment, location;
    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          teamName = _ref6.teamName, apolloClient = _ref6.apolloClient, environment = _ref6.environment;
          if (environment) {
            configureApolloForCommerce(isProd(environment.toString()), window.location.hostname);
          }
          location = getWindowLocation() || "clientside request ".concat(queryType);
          return _context6.abrupt("return", makeApolloClientRequest(apolloClient, _objectSpread({
            fetchPolicy: ApolloFetchPolicy.NO_CACHE,
            errorPolicy: ApolloErrorPolicy.ALL,
            query: query
          }, environment && {
            context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
          }), {
            teamName: teamName,
            location: location
          }));
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee5);
  }));
  return function makeRequest(_x6, _x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/SubscriptionUtil/clientSide/index.js
// module id = 1442
// module chunks = 11